import React from 'react';
import { Stack, TextField } from '@mui/material';
import { twoColRow } from '../styles';

interface WelcomeEmailSectionProps {
  subject: string;
  message: string;
  onSubjectChange: (value: string) => void;
  onMessageChange: (value: string) => void;
  offerPercent?: number;
  onOfferPercentChange: (value: number | undefined) => void;
  offerValidity?: number;
  onOfferValidityChange: (value: number | undefined) => void;
  offerCode?: string;
  onOfferCodeChange: (value: string | undefined) => void;
  offerDetails?: string;
  onOfferDetailsChange: (value: string | undefined) => void;
  labels: {
    checkinsWelcomeSubjectLabel?: string;
    checkinsWelcomeSubjectPlaceholder?: string;
    checkinsWelcomeMessageLabel?: string;
    checkinsWelcomeMessagePlaceholder?: string;
    checkinsOfferPercentLabel?: string;
    checkinsOfferPercentPlaceholder?: string;
    checkinsOfferValidityLabel?: string;
    checkinsOfferValidityPlaceholder?: string;
    checkinsOfferCodeLabel?: string;
    checkinsOfferCodePlaceholder?: string;
    checkinsOfferDetailsLabel?: string;
    checkinsOfferDetailsPlaceholder?: string;
    checkinsEmailTemplateHint?: string;
  };
}

const WelcomeEmailSection: React.FC<WelcomeEmailSectionProps> = ({
  subject,
  message,
  onSubjectChange,
  onMessageChange,
  offerPercent,
  onOfferPercentChange,
  offerValidity,
  onOfferValidityChange,
  offerCode,
  onOfferCodeChange,
  offerDetails,
  onOfferDetailsChange,
  labels,
}) => (
  <Stack spacing={2}>
    <TextField
      label={labels.checkinsWelcomeSubjectLabel || 'Email subject'}
      placeholder={
        labels.checkinsWelcomeSubjectPlaceholder || 'Thanks for checking in!'
      }
      value={subject}
      onChange={e => onSubjectChange(e.target.value)}
      fullWidth
    />
    <TextField
      label={labels.checkinsWelcomeMessageLabel || 'Email message'}
      placeholder={
        labels.checkinsWelcomeMessagePlaceholder ||
        'Hi there! Thanks for checking in with us...'
      }
      value={message}
      onChange={e => onMessageChange(e.target.value)}
      fullWidth
      multiline
      minRows={4}
    />
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={twoColRow}>
      <TextField
        type="number"
        label={labels.checkinsOfferPercentLabel || 'Offer (% off)'}
        placeholder={labels.checkinsOfferPercentPlaceholder || '20'}
        value={typeof offerPercent === 'number' ? offerPercent : ''}
        onChange={e => {
          const val = e.target.value;
          if (val === '') {
            onOfferPercentChange(undefined);
            return;
          }
          const num = Number(val);
          onOfferPercentChange(Number.isNaN(num) ? undefined : num);
        }}
        fullWidth
      />
      <TextField
        type="number"
        label={labels.checkinsOfferValidityLabel || 'Offer validity (days)'}
        placeholder={labels.checkinsOfferValidityPlaceholder || '14'}
        value={typeof offerValidity === 'number' ? offerValidity : ''}
        onChange={e => {
          const val = e.target.value;
          if (val === '') {
            onOfferValidityChange(undefined);
            return;
          }
          const num = Number(val);
          onOfferValidityChange(Number.isNaN(num) ? undefined : num);
        }}
        fullWidth
      />
    </Stack>
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField
        label={labels.checkinsOfferCodeLabel || 'Redemption code'}
        placeholder={labels.checkinsOfferCodePlaceholder || 'WELCOME20'}
        value={offerCode || ''}
        onChange={e => onOfferCodeChange(e.target.value || undefined)}
        fullWidth
      />
      <TextField
        label={labels.checkinsOfferDetailsLabel || 'Fine print / details'}
        placeholder={
          labels.checkinsOfferDetailsPlaceholder ||
          'One-time use, in-store only.'
        }
        value={offerDetails || ''}
        onChange={e => onOfferDetailsChange(e.target.value || undefined)}
        fullWidth
      />
    </Stack>
  </Stack>
);

export { WelcomeEmailSection };
